const ASCE_7_16_ROOF_TYPES = {
  FLAT: 0,
  GABLE: 1,
  HIP: 2,
};

export const isASCE716FlatRoof = (roofType: number) => {
  return ASCE_7_16_ROOF_TYPES['FLAT'] === roofType;
};
